import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Container, Card } from "react-bootstrap";
import { FaEye, FaEdit, FaTrash, FaCopy } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { getpackage, deletepackage } from "../../store/slices/package";

import DeleteModal from "./deletepopup";

export default function Package() {
  const navigate = useNavigate();
  const dispatch = useDispatch();


  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [showDelete, setShowDelete] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [deleteStatus, setDeleteStatus] = useState("confirm");

  const itemsPerPage = 25;
  const [currentPage, setCurrentPage] = useState(1);

  const {
    packageList,
    loading,
    pages = 1,
  } = useSelector((state) => state.package);

  const safePackageList = Array.isArray(packageList)
    ? packageList
    : [];

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search.trim());
      setCurrentPage(1);
    }, 500);

    return () => clearTimeout(timer);
  }, [search]);

  const fetchPackages = async () => {
    try {
      const params = {
        page: currentPage,
        limit: itemsPerPage,
      };

      if (debouncedSearch) {
        params.search = debouncedSearch;
      }

      await dispatch(getpackage(params)).unwrap();
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchPackages();
  }, [currentPage, debouncedSearch]);


  const totalPages = pages;
  const startIndex = (currentPage - 1) * itemsPerPage;

  useEffect(() => {
    setCurrentPage(1);
  }, [search]);
  // handledelete
  const handleConfirmDelete = async () => {
    try {
      setDeleteStatus("loading");

      await dispatch(deletepackage(selectedId)).unwrap();
      setDeleteStatus("success");
      setTimeout(() => {
        setShowDelete(false);
        setDeleteStatus("confirm");
      }, 1500);
    } catch (error) {
      setDeleteStatus("confirm");
    }
  };

  return (
    <>
      <div className="breadcrumb-bar mb-2">
        <div className="breadcrumb-left">
          <Link to="/admin/home" className="breadcrumb-link active">
            Home
          </Link>

          <span className="breadcrumb-separator">|</span>

          <span
            className="breadcrumb-link inactive"
            onClick={() => navigate("/admin/packages")}
          >
            Packages
          </span>
        </div>

        <button
          className="add-outlet-btn"
          onClick={() => navigate("/admin/addpackages")}
        >
          + Add Package
        </button>
      </div>
      <Container>
        <Card className="table-border mb-5">
          <Card.Body>
            <div className="guests-table-wrapper common-table-wrapper">
              <div className="d-flex gap-2 mb-3 ms-2 mt-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search package..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  style={{ maxWidth: "300px" }}
                />

                <button
                  className="cancel-btn"
                  onClick={() => {
                    setSearch("");
                    setDebouncedSearch("");
                    setCurrentPage(1);
                  }}
                >
                  Reset
                </button>
              </div>
              <table className="table guests-table common-table align-middle">
                <thead>
                  <tr>
                    <th className="text-center">#</th>
                    <th className="text-center"> Package Name</th>
                    <th className="text-center">Duration</th>
                    <th className="text-center">Category</th>
                    <th className="text-center">Starting Price (Per Pax)</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    [...Array(6)].map((_, index) => (
                      <tr key={index}>
                        <td className="text-center">
                          <div className="skeleton skeleton-text small"></div>
                        </td>

                        <td className="text-center">
                          <div className="skeleton skeleton-text"></div>
                        </td>

                        <td className="text-center">
                          <div className="skeleton skeleton-text"></div>
                        </td>

                        <td className="text-center">
                          <div className="skeleton skeleton-text small"></div>
                        </td>

                        <td className="text-center">
                          <div className="skeleton skeleton-text small"></div>
                        </td>

                        <td className="text-center">
                          <div className="action-btn-group d-flex justify-content-center gap-2">
                            <div className="skeleton skeleton-btn"></div>
                            <div className="skeleton skeleton-btn"></div>
                            <div className="skeleton skeleton-btn"></div>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : safePackageList.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="text-center text-muted">
                        No packages found
                      </td>
                    </tr>
                  ) : (
                    safePackageList.map((pkg, index) => (
                      <tr key={pkg.id}>
                        <td className="text-center">
                          {startIndex + index + 1}
                        </td>
                        <td className="text-center" style={{ maxWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {pkg.title}
                        </td>

                        <td className="text-center">
                          {pkg.durationNights} Nights {pkg.durationDays} Days
                        </td>

                        <td className="text-center">
                          <span
                            bg={pkg.status === "Active" ? "success" : "secondary"}
                          >
                            {pkg.category.name}
                          </span>
                        </td>

                        <td className="text-center">
                          {pkg.pricing?.minPrice}
                        </td>

                        <td className="text-center">
                          <div className="action-btn-group">
                            <button
                              onClick={() =>
                                navigate(`/admin/packagedetails/${pkg._id}`)
                              }
                              className="action-btn edit-btn"
                            >
                              <FaEye size={14} />
                            </button>
                            <button
                              onClick={() =>
                                navigate(`/admin/copypackage/${pkg._id}`)
                              }
                              className="action-btn edit-btn"
                              title="Copy Package"
                            >
                              <FaCopy />
                            </button>
                            <button
                              onClick={() =>
                                navigate(`/admin/editpackage/${pkg._id}`)
                              }
                              state={{ pkg }}
                              className="action-btn edit-btn"
                              title="Edit"
                            >
                              <FaEdit />
                            </button>

                            <button
                              className="action-btn delete-btn"
                              onClick={() => {
                                setSelectedId(pkg._id);
                                setShowDelete(true);
                              }}
                            >
                              <FaTrash size={14} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {!loading && totalPages > 1 && (
              <div className="d-flex justify-content-center align-items-center gap-2 mt-4 flex-wrap">

                {/* PREVIOUS */}
                <button
                  className="btn btn-light"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage(currentPage - 1)}
                >
                  ‹
                </button>

                {/* PAGE NUMBERS */}
                {Array.from(
                  { length: totalPages },
                  (_, i) => i + 1
                )
                  .filter((page) => {
                    return (
                      page === 1 ||
                      page === totalPages ||
                      Math.abs(page - currentPage) <= 1
                    );
                  })
                  .map((page, index, arr) => {
                    const prevPage = arr[index - 1];

                    return (
                      <div
                        key={page}
                        className="d-flex align-items-center gap-2"
                      >
                        {/* DOTS */}
                        {prevPage && page - prevPage > 1 && (
                          <span>...</span>
                        )}

                        <button
                          className={`btn ${currentPage === page
                            ? "btn-dark"
                            : "btn-light"
                            }`}
                          onClick={() => setCurrentPage(page)}
                        >
                          {page}
                        </button>
                      </div>
                    );
                  })}

                {/* NEXT */}
                <button
                  className="btn btn-light"
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage(currentPage + 1)}
                >
                  ›
                </button>
              </div>
            )}
          </Card.Body>
        </Card>
      </Container>

      <DeleteModal
        show={showDelete}
        onHide={() => setShowDelete(false)}
        onConfirm={handleConfirmDelete}
        status={deleteStatus}
      />
    </>
  );
}
